module.exports = __webpack_public_path__ + "img/focus.f1d3c128.svg";